import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 查询支付方式列表数据（#263）
 */
export function getLanguageList() {
  return request("".concat(BASE_URL) + "/language/list", METHOD.GET);
}

/**
 * 上传文件（#263）
 */
export function upload(data) {
  return request("".concat(BASE_URL) + "/common/upload", METHOD.POST, data);
}

/**
 * 获取公共数据 
 */
export function getPublicData() {
  return request("".concat(BASE_URL) + "/common/publicData", METHOD.GET);
}

/**
 * 获取右上角信息（#312） 
 */
export function getInfoTip() {
  return request("".concat(BASE_URL) + "/common/infoTip", METHOD.GET);
}